import {
  MorphemeMnemonicsMeaningViewTab,
  MorphemeMnemonicsPanelContentRoot,
} from "@-/dev.improve.haniverse.routes.nav.app._components.morpheme.panels._views.grapheme.mnemonics._components.panel-content";

export function GraphemeMnemonicsMeaningScreenSuspense() {
  return (
    <MorphemeMnemonicsPanelContentRoot>
      <MorphemeMnemonicsMeaningViewTab />
    </MorphemeMnemonicsPanelContentRoot>
  );
}
